// removed by extract-text-webpack-plugin
module.exports = {"root":"caseTile__root--39xCV","loaded":"caseTile__loaded--3blGs","scale":"caseTile__scale--s7bj7","scaleCards":"caseTile__scaleCards--2L-yw","img":"caseTile__img--3zF6E","details":"caseTile__details--10Mgg","client":"caseTile__client--2MDfw","description":"caseTile__description--1JK2V"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/CaseTile/caseTile.css
// module id = LcxP
// module chunks = 0